import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPause = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "currentColor",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 5,
		y: 4,
		width: 4,
		height: 16
	}), /* @__PURE__ */ _jsx("rect", {
		x: 13,
		y: 4,
		width: 4,
		height: 16
	})]
});
export default SvgPause;
